var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 322.2 261.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00c713;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#00467d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_521",
    "data-name": "Pfad 521",
    className: "cls-1",
    d: "M10.07,141A10.07,10.07,0,0,1,20.14,151h0v70.49a20.14,20.14,0,0,0,20.13,20.14H281.93a20.14,20.14,0,0,0,20.14-20.14h0V151a10.07,10.07,0,1,1,20.13,0v70.49a40.27,40.27,0,0,1-40.27,40.27H40.27A40.27,40.27,0,0,1,0,221.52V151A10.07,10.07,0,0,1,10.07,141Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_522",
    "data-name": "Pfad 522",
    className: "cls-2",
    d: "M100.68,130.9a10.07,10.07,0,0,1,14.24,0l46.18,46.17,46.17-46.17a10.07,10.07,0,0,1,14.24,14.23l-53.29,53.31a10.08,10.08,0,0,1-14.23,0l-53.31-53.3a10.09,10.09,0,0,1,0-14.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_523",
    "data-name": "Pfad 523",
    className: "cls-2",
    d: "M161.09,0a10.07,10.07,0,0,1,10.08,10.06h0v161.1a10.07,10.07,0,0,1-20.14,0h0V10.07A10.07,10.07,0,0,1,161.09,0Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.bab0d60b75d642eb2b6644e2bb435097.svg";
export { ForwardRef as ReactComponent };